import React from "react"

export default function ProhibitedCountriesIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 33 29" fill="none">
			<g fill="#000" fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
				<path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Z" />
				<path d="M8 8V2h2v5.586l1.707 1.707a1 1 0 0 1 .212 1.1l-3 7a1 1 0 0 1-1.473.44l-3-2A1 1 0 0 1 4 15v-1.22l-3.242-.81.485-1.94 4 1A1 1 0 0 1 6 13v1.465L7.555 15.5l2.26-5.273-1.522-1.52A1 1 0 0 1 8 8Zm9.03 5.758A1 1 0 0 1 18 13h5v2h-4.219l-.81 3.242a1 1 0 0 1-.654.707l-2.052.683.684 2.052-1.897.632-1-3a1 1 0 0 1 .632-1.265l2.48-.826.866-3.468Z" />
			</g>
			<circle cx={24.243} cy={20.907} r={7.594} fill="#FF506F" stroke="#fff" />
			<path fill="#fff" d="M20.367 20.305h7.804v1.419h-7.804z" />
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h24v24H0z" />
				</clipPath>
			</defs>
		</svg>
	)
}
